// extracted by mini-css-extract-plugin
export var component = "Header-module--component--IzF1d";
export var controls = "Header-module--controls--QBRwb";
export var inner = "Header-module--inner--bJbDd";
export var logo = "Header-module--logo--gCI6j";
export var mainMenuDesktop = "Header-module--main-menu-desktop--KUyvC";